import React from "react";
import Button from "../shared/Button/Button";

interface CustomImageProps {
  src: string;
  alt: string;
  customClassName?: string;
}

interface HeaderButtonComponentProps {
  buttonText?: any;
  children?: JSX.Element;
  leftIcon?: CustomImageProps;
  rightIcon?: CustomImageProps;
  onClick: () => void;
  customCSS?: string;
  isRedButton?: boolean;
  customButtonHeight?: string;
  customButtonRadius?: string;
  loading?:boolean;
}

const HeaderButtonComponent: React.FC<HeaderButtonComponentProps> = ({
  buttonText = "button",
  children,
  leftIcon,
  rightIcon,
  onClick,
  customCSS,
  isRedButton = false,
  customButtonHeight,
  customButtonRadius,
  loading
}) => {
  return (
    <Button
      className={`flex items-center p-[4px_8px] text-[10px] font-[500] justify-center gap-1
        ${
          buttonText === "Demo" ? "bg-custom-red-gradient text-white" : "text-white"
        }
        ${
        isRedButton ? " bg-custom-red-gradient " : "bg-blue4 active:bg-blue5"
      } ${customCSS} ${customButtonHeight || "h-[28px] md:h-[28px]"} ${
        customButtonRadius || "rounded-[5px]"
      }`}
      onClick={onClick}
      loading={loading}
    >
      {leftIcon && (
        <img
          src={leftIcon.src}
          alt={leftIcon.alt}
          className={leftIcon.customClassName || "h-2.5 w-2.5"}
        />
      )}
      {children ? (
        children
      ) : (
        <span className="text-xs md:text-[13px]  text-white font-bold">
          {buttonText}
        </span>
      )}
      {rightIcon && (
        <img
          src={rightIcon.src}
          alt={rightIcon.alt}
          className={rightIcon.customClassName || "h-2.7 w-2.7 "}
        />
      )}
    </Button>
  );
};

export default HeaderButtonComponent;
